<div class="modal-header">
    <h4 class="modal-title" translate>{{txt.header}}</h4>
</div>
<div class="modal-body u--text-center">
    <span [innerHTML]="txt.body" translate></span>
    <form [formGroup]="form" autocomplete="off">
        <app-select-input
                        [items]="drivers$|async"
                        [multiple]="false"
                        [max]="1"
                        selectClass="w-50"
                        [allowClear]="true"
                        [showTags]="false"
                        [searchable]="true"
                        bindLabel="fullName"
                        bindValue="id"
                        formControlName="selectedDriver"
                >
                    <label translate>DRIVER</label>
                </app-select-input>
        <span class="error-text" @showError [innerHTML]="formErrors"></span>
    </form>
</div>
<div class="modal-footer mt-3">
    <button class="btn btn-primary px-xl btn-border" (click)="activeModal.dismiss()" translate>CANCEL</button>
    <button class="btn btn-danger px-xl" (click)="onSubmitClick()" [disabled]="pending" translate>
        <app-spinner [showSpinner]="pending"></app-spinner>
        {{txt.submit}}
    </button>
</div>
